import { DateTime } from 'luxon';
const getDateFromISOToLocal = (date, format) => DateTime.fromISO(`${date}Z`).toLocaleString(format !== null && format !== void 0 ? format : DateTime.DATETIME_MED);
export default getDateFromISOToLocal;
